@if (courses() !== null && !error()) {
	<uc-main-header
		[heading]="headerTitle()"
		[description]="headerDescription()"
		backgroundStyle="bg-course-search-clearing"
		textColor="text-white"
		descriptionColor="text-white"
	>
		<div class="mt-8">
			<uc-course-search-bar
				[options]="studyLevelOptions"
				[subject]="searchTerm()"
				[autoSuggestEnabled]="true"
				(enter)="onSearch($event)"
				placeholder="Search Courses"
				[searchLocation]="headerSearchBar"
			/>
		</div>
	</uc-main-header>

	<uc-filter-dark-overlay
		[showOverlay]="filterTogglerSrv.displayFilter"
		(click)="filterTogglerSrv.toggle(false)"
	/>

	@if (shouldDisplayCourses()) {
		<div
			class="container py-12 sm:pt-12 sm:pb-16 lg:overflow-visible"
			id="course-search-container"
		>
			<div class="flex justify-between w-full">
				<!-- filter -->
				<uc-clearing-course-search-filter
					class="flex-shrink-0 block lg:flex course-search-filter"
					[ngClass]="{
						open: filterTogglerSrv.displayFilter,
					}"
					[subject]="searchTerm()"
					[location]="location()"
					[ucasPoints]="ucaspts()"
					[degree]="selectedDegree()"
					[studyMode]="studyMode()"
					(autosuggest)="onSearch($event)"
					(closeFilter)="filterTogglerSrv.toggle(false)"
					(filterChange)="onFilterChange($event)"
					(filterReset)="onFilterReset()"
					(studyLevelChange)="onStudyLevelSelect($event)"
					[isClearingSearch]="true"
				/>

				<main class="w-full">
					@if (isLoading()) {
						<uc-universities-skeleton [filter]="false" />
					} @else {
						<div class="flex-grow w-full search-container">
							<uc-filter-sort-widget
								[total]="courses()?.total ?? 0"
								[totalPills]="filterPillsCount()"
								text="courses found"
								studyLevel="clearing"
								(toggleFilter)="filterTogglerSrv.toggle()"
							/>
							<uc-course-search-result
								[resultLength]="courses()?.data?.length"
								[showIndividualUniCourses]="false"
								[degreeLevel]="'clearing'"
								[relatedSubjects]="courses()?.related_subjects"
								[showIndividualUniCourses]="false"
								(relatedSubject)="onRelatedSubject($event)"
								product="clearing"
								(studyLevelChange)="onStudyLevelSelect($event)"
							>
								<!-- courses  -->
								<uc-course-list-clearing
									[subjectKeywords]="
										courses()?.recommended_courses ?? []
									"
									[unis]="courses()?.data ?? []"
									[searchTerm]="searchTerm()"
								/>
							</uc-course-search-result>

							<!-- load more  -->
							@if (showLoadMore()) {
								<uc-course-search-pagination
									[hasMorePages]="!!courses()?.has_more_pages"
									[isLoading]="isPaginationLoading()"
									[searchTerm]="searchTerm()"
									[page]="courses()?.current_page ?? 1"
									(loadMore)="onLoadMore($event)"
								/>
							}
						</div>
					}
				</main>
			</div>
		</div>
	}
} @else if (isLoading() && courses() === null) {
	<uc-universities-skeleton class="container block" />
} @else if (!isLoading() && error()) {
	<uc-course-search-error />
}

@if (faq) {
	<div class="container">
		<div class="border-t">
			<uc-faq-accordion
				[faq]="faq"
				[ugSearchOrderPosition]="null"
				[cleSearchOrderPosition]="null"
			/>
		</div>
	</div>
}

@if (selectedDegree() === 'clearing' && courses()?.data?.length) {
	<uc-directory-card-cta
		slug="/directory/clearing"
		cardTitle="Clearing Directory"
		cardDesc="Looking for more? Discover the A-Z of Clearing subjects in the directory."
		buttonText="View all Clearing courses"
	/>
}
